module.exports = __webpack_public_path__ + "img/advertiser.b475e106.svg";